import { getColor, hexToColorName } from 'common/constants/_colors';
import ColorPickerPallete from 'components/base/ColorPickerPallete';
import { GRAPH_COLORS } from '../../consts/colors';
import GraphPicker from '../../../GraphPicker';
import Icon from 'components/base/Icon';
import Tooltip from '@material-ui/core/Tooltip';
import EditDefaultsMenu from '../EditDefaultsMenu';
import { GRAPH_TYPES } from '../../consts/graphTypes';
import { LBButton } from '@linearb/buzz';

const EditDefaults = ({
  isEditable,
  isMedian = false,
  editConfig,
  isHover,
  graphType,
  color,
  onColorChange,
  onGraphTypeChange,
  onRemove
}) => {
  if (!isEditable || !isHover) {
    return null;
  }

  if (isMedian) {
    return (
      <EditDefaultsMenu
        editConfig={editConfig}
        graphType={graphType ?? GRAPH_TYPES.LINE}
        color={color}
        onColorChange={onColorChange}
        onGraphTypeChange={onGraphTypeChange}
        onRemove={onRemove}
      />
    );
  }

  return (
    <div className='flex flex-row gap-1 mr-1'>
      {editConfig.canChangeColor && (
        <ColorPickerPallete
          selectedGraph={graphType}
          boxSize='1rem'
          chunks={1}
          title='Change color'
          openOnTop={true}
          selectedColor={getColor(color ?? 'dodgerBlue')}
          onChange={color => onColorChange(hexToColorName(color))}
          container={(children, onClick) => (
            <LBButton
              variant='ghost'
              size='icon'
              data-testid='color-picker'
              onClick={onClick}
              aria-controls='simple-menu'
              aria-haspopup='true'
            >
              <div className='flex items-center justify-center ml-[3px]'>
                {children}
              </div>
            </LBButton>
          )}
          colors={GRAPH_COLORS}
        />
      )}
      {editConfig.canChangeType && (
        <GraphPicker
          chunks={1}
          title='Change type'
          openOnTop={true}
          selectedGraph={graphType}
          onChange={onGraphTypeChange}
          container={(children, onClick) => (
            <LBButton
              variant='ghost'
              size='icon'
              data-testid='graph-picker'
              onClick={onClick}
            >
              {children}
            </LBButton>
          )}
        />
      )}
      {editConfig.canDelete && (
        <Tooltip title='Remove from dashboard' placement='top'>
          <LBButton
            onClick={onRemove}
            data-testid='remove-graphbox'
            variant='ghost'
            size='icon'
          >
            <Icon size='medium' name='Trash' alpha={0.7} />
          </LBButton>
        </Tooltip>
      )}
    </div>
  );
};

export default EditDefaults;
